import { Stack, Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { React } from 'react'
import { useCookies } from 'react-cookie'
import GoingCloudLogo from '../assets/images/Going_Cloud_Logo@2x.svg'
import { awsConfig, commonConfig } from '../config'
import Styles from '../style/theme'

const LogOut = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#FFFFFF',
  width: '61px',
  height: '24px',
})

function Navbar() {
  const [, , removeCookie] = useCookies()

  const logout = () => {
    removeCookie(awsConfig.cookieKey)
    window.location.href = `${awsConfig.cognitoDomain}/logout?client_id=${awsConfig.clientId}&logout_uri=${commonConfig.domain}`
  }

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: Styles.Color.PrimaryDarkBlue,
        height: '80px',
      }}>
      <Box ml="24px">
        <img src={GoingCloudLogo} alt="GoingCloudLogo" width="160px" height="54px" />
      </Box>
      <Stack mr="24px" justifyContent="center" alignItems="center" sx={{ width: '93px', height: '44px', cursor: 'pointer' }} onClick={logout}>
        <LogOut>LogOut</LogOut>
      </Stack>
    </Stack>
  )
}

export default Navbar
